import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1467c60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "欢迎您的咨询！", -1))
const _hoisted_5 = { class: "content" }

import { watchEffect } from 'vue'
import consultForm from './form.vue'
import consultPhone from './phone.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean },
    isWorkday: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    modelValue: boolean,
    isWorkday: boolean,
}





function disableScroll() {
    function mo(e: Event) { e.preventDefault(); };
    document.body.style.overflow = 'hidden';
    document.addEventListener("touchmove", mo, false);//禁止页面滑动
}
function setScroll() {
    function mo(e: Event) { e.preventDefault(); };
    document.body.style.overflow = '';//出现滚动条
    document.removeEventListener("touchmove", mo, false);
}
watchEffect(() => {
    if (props.modelValue) {
        disableScroll()
    } else {
        setScroll()
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popup", __props.modelValue ? 'popup-fade-in' : 'popup-fade-out'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "header-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        }),
        _createElementVNode("img", {
          class: "header-logo",
          src: require('@/assets/images/consult/logo.png')
        }, null, 8, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(__props.isWorkday ? consultPhone : consultForm)))
      ])
    ])
  ], 2))
}
}

})